import { Plus, X } from "lucide-react";
import { DEFAULT_TIME_WINDOW, DAYS_OF_WEEK } from "@/constants/segmentOptions";

export default function ScheduleEditor({ value, onChange }) {
  const schedule = value ?? DEFAULT_TIME_WINDOW;
  const rules = Array.isArray(schedule.rules) ? schedule.rules : [];

  const setRules = (next) => onChange({ ...schedule, rules: next });
  const updateRule = (i, patch) =>
    setRules(rules.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const toggleDay = (i, day) => {
    const days = new Set(Array.isArray(rules[i].days) ? rules[i].days : []);
    days.has(day) ? days.delete(day) : days.add(day);
    updateRule(i, { days: [...days] });
  };
  const addRule = () =>
    setRules([
      ...rules,
      {
        days: ["mon", "tue", "wed", "thu", "fri"],
        start: "09:00",
        end: "21:00",
      },
    ]);

  return (
    <div className="flex flex-col gap-2.5">
      {rules.map((rule, i) => (
        <div key={i} className="flex flex-wrap items-center gap-1.5">
          {DAYS_OF_WEEK.map((d) => {
            const active = (rule.days ?? []).includes(d.value);
            return (
              <button
                key={d.value}
                type="button"
                onClick={() => toggleDay(i, d.value)}
                className={`rounded-(--radius-pill) border px-2 py-0.5 text-xs font-medium transition-colors ${
                  active
                    ? "border-(--brand-primary) bg-(--pastel-violet) text-(--brand-primary)"
                    : "border-(--border-subtle) text-(--text-secondary) hover:border-(--brand-primary)"
                }`}
              >
                {d.label}
              </button>
            );
          })}
          <div className="ml-1 flex items-center gap-1">
            <input
              type="time"
              value={rule.start ?? "00:00"}
              onChange={(e) => updateRule(i, { start: e.target.value })}
              className="rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-1) px-2 py-1 text-xs text-(--text-primary)"
            />
            <span className="text-xs text-(--text-muted)">–</span>
            <input
              type="time"
              value={rule.end ?? "23:59"}
              onChange={(e) => updateRule(i, { end: e.target.value })}
              className="rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-1) px-2 py-1 text-xs text-(--text-primary)"
            />
          </div>
          <button
            type="button"
            onClick={() => setRules(rules.filter((_, idx) => idx !== i))}
            className="ml-0.5 flex h-6 w-6 items-center justify-center rounded-(--radius-sm) text-(--text-muted) hover:bg-(--surface-1) hover:text-(--status-danger)"
            aria-label="Remove window"
          >
            <X size={14} />
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={addRule}
        className="inline-flex w-fit items-center gap-1 text-xs font-medium text-(--brand-primary) hover:underline"
      >
        <Plus size={12} /> Add time window
      </button>
    </div>
  );
}
